/**
 * Category Service
 * 
 * Handles report category CRUD via the API.
 */

import apiClient from './api';

/**
 * Get all categories
 */
export const getCategories = async () => {
  try {
    const response = await apiClient.get('/categories');
    const apiData = response.data?.data || response.data;
    const list = apiData?.categories || [];
    return list.map(c => ({
      id: c.ID,
      name: c.NAME,
      description: c.DESCRIPTION || '',
      team: c.TEAM || '',
      createdAt: c.CREATED_AT || '',
      updatedAt: c.UPDATED_AT || ''
    }));
  } catch (error) {
    console.error('Failed to fetch categories:', error);
    throw error;
  }
};

/**
 * Create a new category
 */
export const createCategory = async (data) => {
  try {
    const response = await apiClient.post('/categories', {
      name: data.name,
      description: data.description || '',
      team: data.team || 'UK & I Reporting'
    });
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Failed to create category:', error);
    throw error;
  }
};

/**
 * Update a category
 */
export const updateCategory = async (id, data) => {
  try {
    await apiClient.put(`/categories/${id}`, {
      name: data.name,
      description: data.description || '',
      team: data.team || ''
    });
    return { success: true };
  } catch (error) {
    console.error('Failed to update category:', error);
    throw error;
  }
};

/**
 * Delete a category
 */
export const deleteCategory = async (id) => {
  try {
    await apiClient.delete(`/categories/${id}`);
    return { success: true };
  } catch (error) {
    console.error('Failed to delete category:', error);
    throw error;
  }
};
